const prevArrow = `<div class="slick-arrow slider-button--prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left-icon lucide-chevron-left"><path d="m15 18-6-6 6-6"/></svg></div>`;
const nextArrow = `<div class="slick-arrow slider-button--next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right-icon lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg></div>`;

document.addEventListener("DOMContentLoaded", () => {
  $(".MineSliderrrr").slick({
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 6,
    slidesToScroll: 2,
    prevArrow,
    nextArrow,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
});
